<template>
  <div>
    <div class="enrollInvite">
      <b-tabs content-class="mt-3" lazy nav-class="justify-content-start">
        <b-tab v-for="(subgroup, subgroupIndex) in subgroupComponents" :key="subgroupIndex" :title="subgroup.name">
          <component :getCustomNames="getCustomNames" :groupInfo="groupInfo" v-bind:is="subgroup.component"></component>
        </b-tab>
      </b-tabs>

    </div>
  </div>
</template>

<script>
import InstituteGroupSubGroupEnrollment from "./InstituteGroupSubGroupEnrollment.vue";
import InstituteSubgroupInvite from "../../invite/InstituteSubgroupInvite.vue";
import EnrolledUsers from "./EnrolledUsers.vue";
import NewAdmissions from "./NewAdmissions.vue";
export default {
  props: ["groupInfo"],
  async created() {
    if (this.groupInfo.type == (await "Subgroup")) {
      this.enrollUserToSubgroup();
    }
    if (
      this.view == (await "Enroll") &&
      this.groupInfo.type == (await "Group")
    ) {
      this.enrollUserToGroup();
    }
  },
  computed: {
    getCustomNames() {
      return this.$store.getters.getCustomNamings;
    },
  },
  components: {
    InstituteGroupSubGroupEnrollment,
    InstituteSubgroupInvite,
    EnrolledUsers,
    NewAdmissions
  },
  data() {
    return {
      view: "Enroll",
      subgroupComponents: [
        { name: "Enrolled Student List", component: EnrolledUsers },
        { name: "Transfer/Promote", component: InstituteGroupSubGroupEnrollment },
        { name: "Invite Student", component: InstituteSubgroupInvite },
        { name: "New Admissions", component: NewAdmissions },
      ],
    };
  },
  methods: {
    async viewType(viewType) {
      this.view = await viewType;
      if (
        this.view == (await "Enroll") &&
        this.groupInfo.type == (await "Subgroup")
      ) {
        this.enrollUserToSubgroup();
      }
      if (
        this.view == (await "Enroll") &&
        this.groupInfo.type == (await "Group")
      ) {
        this.enrollUserToGroup();
      }
      if (this.view == (await "List")) {
        this.usersList();
      }
    },
    async enrollUserToSubgroup() {
      if (this.$refs.userEnroll){
        this.$refs.userEnroll.options = [];
        this.$refs.userEnroll.students = [];
        await this.$refs.userEnroll.studentDetails();
      }
    },
    async enrollUserToGroup() {
      this.$refs.userEnroll.options = [];
      this.$refs.userEnroll.faculty = [];
      await this.$refs.userEnroll.facultyDetails();
    },
    async usersList() {
      this.$refs.usersList.fetchData = await true;
      if (this.groupInfo.type == "Subgroup") {
        await this.$refs.usersList.getEnrolledSubgroupUsers();
      } else {
        await this.$refs.usersList.getEnrolledGroupUsers();
      }

      this.$refs.usersList.fetchData = await false;
    },
    closeEnrollInvite() {
      this.$parent.enrollAndInvite = false;
      this.$parent.groupInfo.id = "";
      this.$parent.groupInfo.name = "";
    },
  },
};
</script>

<style>
/* Center the tabs */
.enrollInvite .nav-tabs {
  display: flex;
  justify-content: center;
  /* centers tabs horizontally */
  flex-wrap: wrap;
  /* if too many tabs, allow wrapping */
}

/* Default tab (not selected) */
.enrollInvite .nav-tabs .nav-item .nav-link {
  background-color: #0d6efd;
  /* info color */
  color: white;
  border-radius: 5px 5px 0 0;
  margin: 0 5px;
  /* spacing between tabs */
}

/* Selected tab */
.enrollInvite .nav-tabs .nav-item .nav-link.active {
  background-color: #fff;
  /* white for active */
  color: #0d6efd;
  border-color: #17a2b8 #17a2b8 #fff;
  font-weight: bold;
}
</style>
